// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/nl-NL';

import landingFreeBundle from './LandingFreeBundle';

// Tenant-specific styles
import '../../../scss/site/pages/LandingFreeBundle/LandingFreeBundle.mp.scss';

landingFreeBundle(i18n);
